import React from 'react'
import {
    Row,
    Col
} from 'antd'
import './style.scss'
import {connect} from 'react-redux'
class Om extends React.Component{
    constructor(props){
        super(props);
        this.state = {

        }
    }
    render(){
        const {content, isLoading} = this.props.Content
        if(content){
            const {img, text,header} = content.About
            return(
                <div className="">
                    <Row>
                        <Col span={6} push={18}>
                            <div className="sidenav">
                                <h2 className="title">Om I. Sundgren</h2>
                                {/*
                                <p className="item">Våre ansatte</p>
                                <p className="item">Ledelse</p>
                                <p className="item">Historie</p>*/}
                            </div>
                        </Col>
                        <Col span={18} pull={6}>
                           <div className="Om">
                            <img src={img} alt=""/>
                                <h1>{header}</h1>
                                <p className="about">
                                    {text.map((paragraph) => (
                                        <span>{paragraph} <br/><br/></span>
                                    ))}
                                </p>
                           </div>
                        </Col>
                        
                    </Row>
                </div>
            )
        }else{
            return(
                <div className="">spin</div>
            )
        }
    }
}
const mapStateToProps = (store) => ({
    Content: store.content
  })
export default connect(mapStateToProps)(Om);